import { Form } from "@repo/ui";
import { useForm } from "react-hook-form";
import FormInput from "ui/Input";

export default function UserDetails({ user }) {
  const form = useForm({ defaultValues: { ...user } });
  const generalProps = { errors: form.formState.errors, control: form.control };
  return (
    <div className="form-container" style={{ margin: 0 }}>
      <Form {...form}>
        <form className="custom-form-v2">
          <h1 className="text-lg font-medium">Employee Details</h1>
          {/* <div className="flex flex-row justify-end w-full my-2">
            <Link>
              <Button variant={"secondary"}>Open Records</Button>
            </Link>
          </div> */}
          <div className="dialogue-form-row mt-4">
            <FormInput
              {...generalProps}
              name="userName"
              label="User Name"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="name"
              label="Name"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="employeeId"
              label="Employee Id"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="cenconId"
              label="Cencon Id"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="email"
              label="Email"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="mobileNo"
              label="Phone No"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="assignment"
              label="Assignment"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="designation"
              label="Designation"
              hideIcons
              inputProps={{ readOnly: true }}
            />
          </div>
        </form>
      </Form>
    </div>
  );
}
